import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './calculator-solar-savings-tab.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
var CalculatorSolarSavingsTab = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorSolarSavingsTab, _super);
    function CalculatorSolarSavingsTab(element) {
        return _super.call(this, element) || this;
    }
    CalculatorSolarSavingsTab.prototype.init = function () {
        TooltipsService.initTooltips();
        this.form = this.element.querySelector('form');
        this.monthlyRepaymentElement = this.element.querySelector('.js-monthly-repayment');
        this.savingsValueElement = this.element.querySelector('.js-savings-value');
        this.savingsCurrencyElement = this.element.querySelector('.calculator-solar-savings-tab__results-amount-currency');
        this.eskomFeeElement = this.element.querySelector('.eskom-savings');
        this.solarFeeElement = this.element.querySelector('.solar-system-savings');
        this.savingsTitleElement = this.element.querySelector('.js-savings-title');
        this.deficitMessageElement = this.element.querySelector('.js-deficit-message');
        this.clearInputsButton = this.element.querySelector('.js-calculator-clear-inputs');
        this.calculateButton = this.element.querySelector('.js-calculator-calculate');
        this.resultsElement = this.element.querySelector('.calculator-solar-savings-tab__results');
        this.interestRateInput = this.element.querySelector('[name="interest_rate"]');
        this.interestRateDisplay = this.element.querySelector('.js-stepper-display');
        this.stepperMinusButton = this.element.querySelector('.js-stepper-minus');
        this.stepperPlusButton = this.element.querySelector('.js-stepper-plus');
        this.setDefaultValues();
        this.setupValidation();
        this.updateStepperDisplay();
        // Initialize range input display
        var rangeInput = this.form.querySelector('[name="finance_period"]');
        if (rangeInput) {
            this.updateRangeDisplay(rangeInput);
        }
        // Run an initial calculation so the results reflect the default values on load
        if (this.validateAllInputs()) {
            this.calculateSavings();
        }
    };
    CalculatorSolarSavingsTab.prototype.bindEvents = function () {
        var _this = this;
        if (this.clearInputsButton) {
            this.clearInputsButton.addEventListener('click', function (e) {
                e.preventDefault();
                _this.resetForm();
            });
        }
        if (this.calculateButton) {
            this.calculateButton.addEventListener('click', function (e) {
                e.preventDefault();
                clearTimeout(_this.debounceTimer);
                if (_this.validateAllInputs()) {
                    _this.calculateSavings();
                    _this.showCalculationFeedback();
                }
            });
        }
        if (this.stepperPlusButton) {
            this.stepperPlusButton.addEventListener('click', function (e) {
                e.preventDefault();
                _this.handleStepperClick('up');
            });
        }
        if (this.stepperMinusButton) {
            this.stepperMinusButton.addEventListener('click', function (e) {
                e.preventDefault();
                _this.handleStepperClick('down');
            });
        }
        // Range input display update + auto-calculate
        var rangeInput = this.form.querySelector('[name="finance_period"]');
        if (rangeInput) {
            rangeInput.addEventListener('input', function () {
                _this.updateRangeDisplay(rangeInput);
                _this.triggerAutoCalculation();
            });
        }
        // Auto-calculation on all input changes
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                if (input.getAttribute('name') !== 'finance_period' && input.getAttribute('name') !== 'finance_period_display') {
                    input.addEventListener('input', function () {
                        if (input.getAttribute('name') === 'interest_rate') {
                            _this.updateStepperDisplay();
                        }
                        _this.triggerAutoCalculation();
                    });
                }
            });
        }
    };
    CalculatorSolarSavingsTab.prototype.triggerAutoCalculation = function () {
        var _this = this;
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(function () {
            if (_this.validateAllInputs()) {
                _this.calculateSavings();
            }
        }, 300);
    };
    // Give the user clear visual feedback that the (re)calculation ran, since
    // the results often already reflect the latest inputs via auto-calculation.
    CalculatorSolarSavingsTab.prototype.showCalculationFeedback = function () {
        if (this.calculateButton) {
            var button_1 = this.calculateButton;
            var originalText_1 = button_1.textContent;
            button_1.classList.add('is-calculating');
            button_1.disabled = true;
            button_1.textContent = 'Calculating...';
            setTimeout(function () {
                button_1.classList.remove('is-calculating');
                button_1.disabled = false;
                button_1.textContent = originalText_1;
            }, 600);
        }
        if (this.resultsElement) {
            this.resultsElement.classList.remove('is-updated');
            // Force reflow so the animation can be retriggered on repeated clicks.
            void this.resultsElement.offsetWidth;
            this.resultsElement.classList.add('is-updated');
            this.resultsElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    };
    CalculatorSolarSavingsTab.prototype.handleStepperClick = function (direction) {
        if (!this.interestRateInput)
            return;
        var currentValue = parseFloat(this.interestRateInput.value) || 0;
        var step = 0.25;
        if (direction === 'up') {
            currentValue = Math.min(100, currentValue + step);
        }
        else {
            currentValue = Math.max(0.1, currentValue - step);
        }
        // Round to 2 decimal places to avoid floating point issues
        currentValue = Math.round(currentValue * 100) / 100;
        this.interestRateInput.value = currentValue.toString();
        this.updateStepperDisplay();
        this.triggerAutoCalculation();
    };
    CalculatorSolarSavingsTab.prototype.updateStepperDisplay = function () {
        if (!this.interestRateInput || !this.interestRateDisplay)
            return;
        var value = parseFloat(this.interestRateInput.value) || 0;
        this.interestRateDisplay.textContent = value + "%";
        // Disable/enable stepper buttons at boundaries
        if (this.stepperMinusButton) {
            if (value <= 0.1) {
                this.stepperMinusButton.classList.add('disabled');
                this.stepperMinusButton.setAttribute('aria-disabled', 'true');
            }
            else {
                this.stepperMinusButton.classList.remove('disabled');
                this.stepperMinusButton.removeAttribute('aria-disabled');
            }
        }
        if (this.stepperPlusButton) {
            if (value >= 100) {
                this.stepperPlusButton.classList.add('disabled');
                this.stepperPlusButton.setAttribute('aria-disabled', 'true');
            }
            else {
                this.stepperPlusButton.classList.remove('disabled');
                this.stepperPlusButton.removeAttribute('aria-disabled');
            }
        }
    };
    CalculatorSolarSavingsTab.prototype.setDefaultValues = function () {
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                var defaultValue = input.getAttribute('data-value');
                if (defaultValue) {
                    input.value = defaultValue;
                }
            });
        }
    };
    CalculatorSolarSavingsTab.prototype.setupValidation = function () {
        var _this = this;
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                input.addEventListener('input', function () { return _this.validateInput(input); });
            });
        }
    };
    CalculatorSolarSavingsTab.prototype.validateInput = function (input) {
        var value = parseFloat(input.value);
        var name = input.getAttribute('name');
        var fieldContainer = input.closest('.input-wrapper, .col, .calculator-solar-savings-tab__field');
        var validationMessage = fieldContainer ? fieldContainer.querySelector('.validation-message') : null;
        var showError = function (message) {
            if (validationMessage) {
                validationMessage.textContent = message;
                validationMessage.style.display = 'block';
                input.classList.add('is-invalid');
            }
            input.setCustomValidity(message);
            return false;
        };
        var clearError = function () {
            if (validationMessage) {
                validationMessage.style.display = 'none';
                input.classList.remove('is-invalid');
            }
            input.setCustomValidity('');
            return true;
        };
        // Skip readonly/display inputs
        if (name === 'finance_period_display') {
            return true;
        }
        // Special handling for deposit which can be 0
        if (name === 'deposit_price') {
            if (isNaN(value)) {
                return showError('This field is required and must be a number');
            }
            if (value < 0 || value > 99999999) {
                return showError('Value must be between 0 and 99,999,999');
            }
            // Check if deposit exceeds system cost
            var systemCostInput = this.form.querySelector('[name="system_cost_price"]');
            if (systemCostInput) {
                var systemCost = parseFloat(systemCostInput.value);
                if (!isNaN(systemCost) && value > systemCost) {
                    return showError('Deposit cannot be greater than system cost');
                }
            }
            return clearError();
        }
        // For other fields, check if value exists and is a number
        if (isNaN(value)) {
            return showError('This field is required and must be a number');
        }
        switch (name) {
            case 'kwh_per_annum':
                if (value < 1 || value > 99999999) {
                    return showError('Value must be between 1 and 99,999,999');
                }
                break;
            case 'tarif_price':
                if (value < 0.1 || value > 5) {
                    return showError('Value must be between 0.1 and 5.0');
                }
                break;
            case 'system_cost_price':
                if (value < 1 || value > 99999999) {
                    return showError('Value must be between 1 and 99,999,999');
                }
                // When system cost changes, validate deposit is still valid
                var depositInput = this.form.querySelector('[name="deposit_price"]');
                if (depositInput) {
                    var depositValue = parseFloat(depositInput.value);
                    if (!isNaN(depositValue) && depositValue > value) {
                        depositInput.classList.add('is-invalid');
                        var depositField = depositInput.closest('.calculator-solar-savings-tab__field');
                        var depositValidationMessage = depositField ? depositField.querySelector('.validation-message') : null;
                        if (depositValidationMessage) {
                            depositValidationMessage.textContent = 'Deposit cannot be greater than system cost';
                            depositValidationMessage.style.display = 'block';
                        }
                    }
                }
                break;
            case 'finance_period':
                if (value < 36 || value > 60) {
                    return showError('Value must be between 36 and 60 months');
                }
                break;
            case 'interest_rate':
                // Check for empty value first
                if (input.value.trim() === '') {
                    return showError('Interest rate is required');
                }
                // Check for non-numeric characters
                if (!/^\d*\.?\d*$/.test(input.value)) {
                    return showError('Only numbers and decimal point are allowed');
                }
                // Check decimal places (maximum 2 decimal places)
                if (input.value.includes('.') && input.value.split('.')[1].length > 2) {
                    return showError('Maximum 2 decimal places allowed');
                }
                // Check for valid range
                if (value <= 0) {
                    return showError('Interest rate must be above 0%');
                }
                if (value < 0.1) {
                    return showError('Minimum interest rate is 0.1%');
                }
                if (value > 100) {
                    return showError('Maximum interest rate is 100%');
                }
                break;
        }
        return clearError();
    };
    CalculatorSolarSavingsTab.prototype.calculateSavings = function () {
        if (!this.validateAllInputs()) {
            return;
        }
        var kwhPerAnnum = parseFloat(this.getInputValue('kwh_per_annum'));
        var tariff = parseFloat(this.getInputValue('tarif_price'));
        var systemCost = parseFloat(this.getInputValue('system_cost_price'));
        var deposit = parseFloat(this.getInputValue('deposit_price') || '0');
        var financePeriod = parseFloat(this.getInputValue('finance_period'));
        var interestRate = parseFloat(this.getInputValue('interest_rate'));
        // Calculate Eskom cost
        var eskomCostPerAnnum = kwhPerAnnum * tariff;
        // Calculate Solar financing cost
        var loanAmount = systemCost - deposit;
        var monthlyInterestRate = (interestRate / 100) / 12;
        var monthlyPayment = this.calculatePMT(monthlyInterestRate, financePeriod, loanAmount);
        var annualSolarCost = monthlyPayment * 12;
        // Calculate savings
        var annualSavings = eskomCostPerAnnum - annualSolarCost;
        // Update display
        this.updateDisplay(annualSavings, eskomCostPerAnnum, annualSolarCost);
    };
    CalculatorSolarSavingsTab.prototype.calculatePMT = function (rate, nper, pv) {
        var principal = Math.abs(pv);
        if (rate === 0)
            return principal / nper;
        var pvif = Math.pow(1 + rate, nper);
        var pmt = (rate * principal * pvif) / (pvif - 1);
        return pmt;
    };
    CalculatorSolarSavingsTab.prototype.validateAllInputs = function () {
        var _this = this;
        var isValid = true;
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                if (input.getAttribute('name') !== 'finance_period_display') {
                    if (!_this.validateInput(input)) {
                        isValid = false;
                    }
                }
            });
        }
        return isValid;
    };
    CalculatorSolarSavingsTab.prototype.getInputValue = function (name) {
        if (this.form) {
            var input = this.form.querySelector("[name=\"" + name + "\"]");
            if (name === 'deposit_price' && input && input.value === '') {
                return '0';
            }
            return input ? input.value || '0' : '0';
        }
        return '0';
    };
    CalculatorSolarSavingsTab.prototype.updateDisplay = function (savings, eskomCost, solarCost) {
        if (this.monthlyRepaymentElement && this.eskomFeeElement && this.solarFeeElement &&
            this.savingsTitleElement && this.deficitMessageElement) {
            var formatNumber = function (num) {
                return Math.abs(num).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            };
            var isDeficit = savings < 0;
            // Update title and message visibility
            this.savingsTitleElement.textContent = isDeficit ? 'Your estimated annual deficit' : 'Your estimated annual savings:';
            this.deficitMessageElement.style.display = isDeficit ? 'block' : 'none';
            // Update the savings/deficit amount. The R currency symbol and the
            // "p.a" suffix are static elements in the markup, so we only write
            // the formatted number here (prefixing a minus sign for a deficit).
            if (this.savingsValueElement) {
                this.savingsValueElement.textContent = "" + (isDeficit ? '-' : '') + formatNumber(savings);
            }
            if (this.savingsCurrencyElement) {
                this.savingsCurrencyElement.textContent = 'R';
            }
            this.eskomFeeElement.textContent = formatNumber(eskomCost) + " p.a";
            this.solarFeeElement.textContent = formatNumber(solarCost) + " p.a";
        }
    };
    CalculatorSolarSavingsTab.prototype.resetForm = function () {
        this.setDefaultValues();
        if (this.savingsValueElement) {
            this.savingsValueElement.textContent = '0.00';
        }
        if (this.savingsCurrencyElement) {
            this.savingsCurrencyElement.textContent = 'R';
        }
        this.eskomFeeElement.textContent = '00 p.a';
        this.solarFeeElement.textContent = '00 p.a';
        this.savingsTitleElement.textContent = 'Your estimated annual savings:';
        this.deficitMessageElement.style.display = 'none';
        // Clear all validation messages
        if (this.form) {
            var validationMessages = this.form.querySelectorAll('.validation-message');
            var inputs = this.form.querySelectorAll('input');
            validationMessages.forEach(function (message) {
                message.style.display = 'none';
            });
            inputs.forEach(function (input) {
                input.classList.remove('is-invalid');
                input.setCustomValidity('');
            });
        }
        // Reset range display
        var rangeInput = this.form.querySelector('[name="finance_period"]');
        if (rangeInput) {
            this.updateRangeDisplay(rangeInput);
        }
        // Reset stepper display
        this.updateStepperDisplay();
    };
    CalculatorSolarSavingsTab.prototype.updateRangeDisplay = function (rangeInput) {
        var months = parseInt(rangeInput.value);
        var years = Math.floor(months / 12);
        var rangeDisplay = this.element.querySelector('.calculator-solar-savings-tab__range-label');
        var monthsDisplay = this.form.querySelector('[name="finance_period_display"]');
        if (rangeDisplay) {
            rangeDisplay.textContent = months + " Months / " + years + " Years";
        }
        if (monthsDisplay) {
            monthsDisplay.value = months.toString();
        }
    };
    return CalculatorSolarSavingsTab;
}(Base));
export { CalculatorSolarSavingsTab };



//////////////////
// WEBPACK FOOTER
// ./components/calculator-solar-savings-tab/calculator-solar-savings-tab.component.ts
// module id = 1131
// module chunks = 0